/*********
 Header Sticky
 **********/


/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
}

// close nav
function closeNav() {
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

//close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// Toggle dropdown
function toggleDropdown(menu) {
    // Plus or Minus icon depending on if its open or closed
    if (menu.classList.contains("active")) {
        menu.querySelector(".sliderNavToggleIcon").classList.remove("fa-minus");
        menu.querySelector(".sliderNavToggleIcon").classList.add("fa-plus");
    } else {
        menu.querySelector(".sliderNavToggleIcon").classList.remove("fa-plus");
        menu.querySelector(".sliderNavToggleIcon").classList.add("fa-minus");
    }

    menu.classList.toggle("active");
}

// Toggle dropdown listener
document.querySelectorAll(".sliderNavItemGroup").forEach((element) => {
    element.addEventListener("click", () => toggleDropdown(element))
})

/***************
 Quick Nav
 **************/

// chemicals link, open nav
document.querySelector(`#quickMenu a[href="/collections/for-pools"]`)?.addEventListener("click", function (e) {
    e.preventDefault();

    // open nav
    openNav();

    // open chemicals dropdown if parent isn't open already
    let item = document.querySelector(`.sliderNavItem[data-href="#chemicals"]`);
    if (!item.closest(".sliderNavItemGroup.active")) item.click();
});